import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { PositionalItem } from '@/models/Answer';
import { AnswerContent } from '@/components/question/view/primitives/shared/AnswerContent';
import { resolveAnswerContentKind } from '@/utils/questions/resolveAnswerContentKind';

type CombinationCueProps = {
  cue: PositionalItem;
};

export function CombinationCue({ cue }: CombinationCueProps) {
  const isImage = resolveAnswerContentKind(cue) === 'image';

  return (
    <ConditionalRenderer
      condition={isImage}
      fallback={
        <span className="shrink-0 font-poppins text-lg font-600 text-base-content text-wrap break-all">
          {cue.text ?? ''}
        </span>
      }
    >
      <div className="grid size-16 shrink-0 place-items-center overflow-hidden bg-base-100 ">
        <AnswerContent answer={cue} className="size-16 object-cover" />
      </div>
    </ConditionalRenderer>
  );
}
